import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  pageName = '';  // optional "page" name; used to go to specific module (i.e. search, minutes, agenda)
  constructor(private router: Router, private route: ActivatedRoute)
 {
 }

  ngOnInit() {

    this.route.queryParamMap.subscribe(params => {
      this.pageName = params.get('se');
      if (this.pageName) {
        if (this.pageName === 'search') {
          this.router.navigate(['/search']);
        } else if (this.pageName === 'agenda') {
            this.router.navigate(['/agenda']);
        } else if (this.pageName === 'minutes') {
          this.router.navigate(['/minutes']);
        } else {
          this.router.navigate(['/home']);
        }
      }
    });

  }

}
